import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
    name: 'writeOff',
    initialState: {
        writeOffAct: '',
        writeOffActs: {
            list: [],
            offset: 0,
            limit: 10,
            count: 0,
            query: '',
            filters: {
                status: 'newAndWork',
                // departmentId: ''
                departmentId: null,
                agreeDirector: '',
                agreeAccountant: '',
            }
        },
    },
    reducers: {
        setWriteOffAct(state, action) {
            state.writeOffAct = action.payload
        },
        setWriteOffActsList(state, action) {
            state.writeOffActs.list = action.payload
        },
        setWriteOffActsOffset(state, action) {
            state.writeOffActs.offset = action.payload
        },
        setWriteOffActsLimit(state, action) {
            state.writeOffActs.limit = action.payload
        },
        setWriteOffActsCount(state, action) {
            state.writeOffActs.count = action.payload
        },
        setWriteOffActsQuery(state, action) {
            state.writeOffActs.query = action.payload
        },
        setWriteOffActsFiltersStatus(state, action) {
            state.writeOffActs.filters.status = action.payload
        },
        setWriteOffActsFiltersDepartmentId(state, action) {
            state.writeOffActs.filters.departmentId = action.payload
        },
        setWriteOffActsFiltersAgreeDirector(state, action) {
            state.writeOffActs.filters.agreeDirector = action.payload
        },
        setWriteOffActsFiltersAgreeAccountant(state, action) {
            state.writeOffActs.filters.agreeAccountant = action.payload
        },
        addWriteOffAct(state, action) {
            state.writeOffActs.list.unshift(action.payload)
        },
        addWriteOffActItem(state, action) {
            if (state.writeOffAct) {
                if (state.writeOffAct['items']) {
                    state.writeOffAct['items'].unshift(action.payload)
                } else {
                    state.writeOffAct['items'] = [action.payload]
                }
            }
        },
        addWriteOffActUser(state, action) {
            if (state.writeOffAct) {
                state.writeOffAct['user'] = action.payload
            }
            // state.writeOffAct.list.unshift(action.payload)
        },
        editWriteOffActItems(state, action) {
            if (state.writeOffAct) {
                state.writeOffAct['items'] = action.payload
            }
            // state.writeOffAct.list.unshift(action.payload)
        },
        editWriteOffActItem(state, action) {
            if (state.writeOffAct && state.writeOffAct.items) {
                state.writeOffAct['items'] = state.writeOffAct['items'].map(item => {
                    if (item.id === action.payload.id) {
                        return action.payload
                    } else {
                        return item
                    }
                })
            }
        },
    }
})

export default slice.reducer

export const {
    setWriteOffAct,
    setWriteOffActsList,
    setWriteOffActsOffset,
    setWriteOffActsLimit,
    setWriteOffActsCount,
    setWriteOffActsQuery,
    setWriteOffActsFiltersStatus,
    setWriteOffActsFiltersDepartmentId,
    setWriteOffActsFiltersAgreeDirector,
    setWriteOffActsFiltersAgreeAccountant,
    addWriteOffAct,
    addWriteOffActItem,
    addWriteOffActUser,
    editWriteOffActItems,
    editWriteOffActItem,
}  = slice.actions